import script from "./ResidentDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ResidentDetailView.vue?vue&type=style&index=0&id=7be58fe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be58fe0"]])

export default __exports__